/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Col, Row, Rate, Typography } from "antd";
import "./Cards.css";
import { BsFillEyeFill } from "react-icons/bs";
import ps_suitcase from "../../../assets/img/ps_suitcase.svg";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import { useSelector } from "react-redux";
import moment from "moment";
import history from "../../../routes/history";
import { DefaultRating } from "../../../assets/helpers";
import PrivateTagSkillListing from "../../../components/PrivateMarketComponents/PrivateTagSkillListing";

const Cards = (props) => {
  const { Text } = Typography;
  const [profilePic, setFavouriesDp] = React.useState();
  // states from Reducers**************** 
  const professionCode = useSelector(state => state.profileReducer.user.profile.ProfessionCode)
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  useEffect(async () => {
    let profilePic = "";
    if (props?.users?.Profiles?.PictureUrl) {
      // profilePic = await getImage(props?.[0].users?.Profiles?.PictureUrl);
      setFavouriesDp(props?.users?.Profiles?.PictureUrl);
    }
  }, [props]);

  // console.log(props?.[0].skill_listings._id);

  const [candidateName, setCandidateName] = useState(null);

  const [candidateTitle, setCandidateTitle] = useState(null);

  const [error, setError] = useState(false);

  // 👇️ if you only need to capitalize first letter
  const capitalizeFirst = str => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };
  
  const rating =[0, null, undefined].includes(props?.users?.Profiles?.Rating) ?0: props?.users?.Profiles?.Rating
  const review =[0, null, undefined].includes(props?.users?.Profiles?.Review) ?null: props?.users?.Profiles?.Review
  useEffect(() => {
    setCandidateName(capitalizeFirst(`${props?.users?.Profiles?.FirstName} ${props?.users?.Profiles?.LastName}`));
    setCandidateTitle(capitalizeFirst(props?.users?.Profiles?.FirstName?.split("")[0]));
  }, [props?.users?.name]);
  return (
    <>
      <div className="card-parent-column"
        onClick={() => {
          history.push({
            pathname: `/profiledetail/${props?.SkillListingId
            }`,
            state: {
              id: props?.SkillListingId
              ,
              token: true,
            }
          });
        }
        }
      >
        <Row className="image-column image-column-private-mkt">
          {userProfile?.Professions?.ProfessionCode === "IT" && userProfile?.EmployeeAssociation?.includes(props?.users?.AccountId) ? <PrivateTagSkillListing /> : null}
          <div className="image-circle-shape">
            {
              profilePic && !error && profilePic?.split("/")?.pop() !== "no-pic.png" ? (
                <img
                  onError={() => setError(true)}
                  className="dp" alt=""
                  // src={profilePic && profilePic}
                  src={`${process.env.REACT_APP_S3_URL}${profilePic?.charAt(0) !== "/" ? '/' : ""
                    }${profilePic}`}
                />
              ) : (
                <div className="dp-text">
                  {props?.users?.Profiles?.FirstName ? candidateTitle : "C"}
                </div>
              )
              // : null
            }
          </div>
          {props?.prevviewed ? <BsFillEyeFill className="eye-icon" /> : null}
        </Row>

        <div className="card-details-column">
          <div className="nameofcandidate">
            {props?.users?.Profiles?.FirstName ? candidateName : "Candidate name"}
          </div>
          <Rate className='card-ratings' allowHalf disabled value={ rating} defaultValue={DefaultRating} />
          <Text style={{ display: "inline" }} className="card-ratings-value">
            <span style={{ color: "#ffba08", fontSize: "12px" }}>
              {rating}
            </span>{" "}
            {review ? `(${review})` : null}
          </Text>
          <div className='card-title'>
            {props?.Title}
          </div>
          <div className="card-desired-rate">
            <Text className="card-desiredrate-text">{ userProfile?.Professions?.ProfessionCode !== 'IT' ? 'Desired rate' : 'Est. Amount'}</Text>
            {props?.MinimumBid
              ? typeof props?.MinimumBid === "object" ? '$' + Math.floor(props?.MinimumBid.$numberDecimal) : '$' + props?.MinimumBid
              : "$Negotiable"}{props?.BudgetTypes ? '/' + props?.BudgetTypes?.BudgetTypeName : props?.MinimumBidType && '/' + props?.MinimumBidType}
            {userProfile?.Professions?.ProfessionCode !== 'IT' ?
              props?.skill_listings?.MinimumBidType &&
              "/" + props?.skill_listings?.MinimumBidType
              : null
            }
          </div>
          <div style={{fontSize: "12px"}}>
            <img style={{paddingBottom: "4px"}} src={ps_suitcase} />
            <span>
            {props?.users?.Profiles?.ExperienceLevels
              ? " " + props?.users?.Profiles?.ExperienceLevels?.ExperienceLevelName
              : " N/A"}
              </span>
          </div>
          <div className="last-active-text">
            {props?.users?.LastSuccessfulLoginDate
              ? "Last active " +
              moment(props?.users?.LastSuccessfulLoginDate).fromNow()
              :  "Last active N/A"}
          </div>
        </div>
      </div>
    </>
  );
};

export default Cards;